import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTES } from 'src/utils/constants';

@Component({
  selector: 'app-phone-verify-component',
  templateUrl: './phone-verify-component.component.html',
  styleUrls: ['./phone-verify-component.component.scss'],
})
export class PhoneVerifyComponentComponent implements OnInit {
  @ViewChild('input2') input2: ElementRef;
  @ViewChild('input3') input3: ElementRef;
  @ViewChild('input4') input4: ElementRef;
  @ViewChild('input5') input5: ElementRef;

  verificationCode: string = '12345';
  activeInput: number = 1;
  userCode: Array<string> = ['', '', '', '', ''];
  codeInvalid: boolean = false;
  timer: any;
  timerValue: number = 59;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.timer = setInterval(() => {
      this.timerValue--;
      if (this.timerValue === 1) {
        clearInterval(this.timer);
      }
    }, 1000);
  }

  verifyCode() {
    this.codeInvalid = false;
    let typedCode = '';
    for (let char of this.userCode) {
      typedCode = typedCode + char;
    }
    if (typedCode === this.verificationCode) {
      this.router.navigate([ROUTES.AUTH.CHECK_MAIL]);
    } else {
      this.codeInvalid = true;
    }
  }

  activateInput(nextInput: any, index: number) {
    if (this.userCode[index] !== '') {
      this.activeInput = index + 2;
      nextInput.focus();
      this.codeInvalid = false;
    }
  }

  sendCodeAgain() {}

  ngOnDestroy(): void {
    clearInterval(this.timer);
  }
}
